import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = 25

export default handleActions(
  {
    [rawActions.setPageSize](state, action) {
      return action.payload
    },
    [rawActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
